import Admin from "../../components/admin/admin.component";
const AdminPage = () => {
    return (
        <div>
            <Admin />
        </div>
    )
}

export default AdminPage;